import React, { useEffect } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { apiEndPoints } from "../../api/network/apiEndPoints";
import { fetchPostDetail } from "../../api/redux/post";

import {
    useParams,
} from "react-router-dom";
import SwiperCore, { Navigation } from "swiper";
import "swiper/swiper-bundle.min.css";
import DetailList from "../../components/DetailList";

const sliderImage = [
    {
        id: 1,
        src : '/images/dynamic/Image-02.jpg'
    },
    {
        id: 2,
        src : '/images/dynamic/Image-02.jpg'
    },
    {
        id: 3,
        src : '/images/dynamic/Image-02.jpg'
    },
    {
        id: 4,
        src : '/images/dynamic/Image-02.jpg'
    },
]

const textSlider = [
    {
        id: 1,
        title: 'Office Building for Infrastructure Development Company Limited (IDCOL),\n' +
            '                                            Government of Bangladesh (GOB)',
        desc: 'The IDCOL-GOB Office Building, designed in 2018, is a striking blend of\n' +
            '                                            modernity and tradition. Its facade harmonizes contemporary elements\n' +
            '                                            with Bangladeshi motifs, creating a dynamic visual effect. Inside, a\n' +
            '                                            well-lit, inviting lobby sets the tone for an uplifting work\n' +
            '                                            environment.\n' +
            '                                            <br/>\n' +
            '                                            <br/>\n' +
            '                                            Sustainability features like green roofs and rainwater harvesting\n' +
            '                                            showcase a commitment to the environment. The layout encourages\n' +
            '                                            collaboration, with open workspaces and meeting zones, complemented by\n' +
            '                                            cutting-edge technology. This building stands as a testament to\n' +
            '                                            progressive values, leaving an indelible mark on Bangladesh’s urban\n' +
            '                                            landscape.',
        year: 2018,
        CompetitionEntry : 'Mohammed Emran Hossain, Shahidullah Faruque, Ashique, Mosrur Helal, Tarek\n' +
            '                                            Islam, Zakir Hossain Opu, Sanam Gulrokh Sathi, Fahim Mahmud Mridul.'
    },
    {
        id: 2,
        title: 'Office Building for Infrastructure Development Company Limited (IDCOL),\n' +
            '                                            Government of Bangladesh (GOB)',
        desc: 'The IDCOL-GOB Office Building, designed in 2018, is a striking blend of\n' +
            '                                            modernity and tradition. Its facade harmonizes contemporary elements\n' +
            '                                            with Bangladeshi motifs, creating a dynamic visual effect. Inside, a\n' +
            '                                            well-lit, inviting lobby sets the tone for an uplifting work\n' +
            '                                            environment.\n' +
            '                                            <br/>\n' +
            '                                            <br/>\n' +
            '                                            Sustainability features like green roofs and rainwater harvesting\n' +
            '                                            showcase a commitment to the environment. The layout encourages\n' +
            '                                            collaboration, with open workspaces and meeting zones, complemented by\n' +
            '                                            cutting-edge technology. This building stands as a testament to\n' +
            '                                            progressive values, leaving an indelible mark on Bangladesh’s urban\n' +
            '                                            landscape.',
        year: 2018,
        CompetitionEntry : 'Mohammed Emran Hossain, Shahidullah Faruque, Ashique, Mosrur Helal, Tarek\n' +
            '                                            Islam, Zakir Hossain Opu, Sanam Gulrokh Sathi, Fahim Mahmud Mridul.'
    },
    {
        id: 3,
        title: 'Office Building for Infrastructure Development Company Limited (IDCOL),\n' +
            '                                            Government of Bangladesh (GOB)',
        desc: 'The IDCOL-GOB Office Building, designed in 2018, is a striking blend of\n' +
            '                                            modernity and tradition. Its facade harmonizes contemporary elements\n' +
            '                                            with Bangladeshi motifs, creating a dynamic visual effect. Inside, a\n' +
            '                                            well-lit, inviting lobby sets the tone for an uplifting work\n' +
            '                                            environment.\n' +
            '                                            <br/>\n' +
            '                                            <br/>\n' +
            '                                            Sustainability features like green roofs and rainwater harvesting\n' +
            '                                            showcase a commitment to the environment. The layout encourages\n' +
            '                                            collaboration, with open workspaces and meeting zones, complemented by\n' +
            '                                            cutting-edge technology. This building stands as a testament to\n' +
            '                                            progressive values, leaving an indelible mark on Bangladesh’s urban\n' +
            '                                            landscape.',
        year: 2018,
        CompetitionEntry : 'Mohammed Emran Hossain, Shahidullah Faruque, Ashique, Mosrur Helal, Tarek\n' +
            '                                            Islam, Zakir Hossain Opu, Sanam Gulrokh Sathi, Fahim Mahmud Mridul.'
    },
    {
        id: 4,
        title: 'Office Building for Infrastructure Development Company Limited (IDCOL),\n' +
            '                                            Government of Bangladesh (GOB)',
        desc: 'The IDCOL-GOB Office Building, designed in 2018, is a striking blend of\n' +
            '                                            modernity and tradition. Its facade harmonizes contemporary elements\n' +
            '                                            with Bangladeshi motifs, creating a dynamic visual effect. Inside, a\n' +
            '                                            well-lit, inviting lobby sets the tone for an uplifting work\n' +
            '                                            environment.\n' +
            '                                            <br/>\n' +
            '                                            <br/>\n' +
            '                                            Sustainability features like green roofs and rainwater harvesting\n' +
            '                                            showcase a commitment to the environment. The layout encourages\n' +
            '                                            collaboration, with open workspaces and meeting zones, complemented by\n' +
            '                                            cutting-edge technology. This building stands as a testament to\n' +
            '                                            progressive values, leaving an indelible mark on Bangladesh’s urban\n' +
            '                                            landscape.',
        year: 2018,
        CompetitionEntry : 'Mohammed Emran Hossain, Shahidullah Faruque, Ashique, Mosrur Helal, Tarek\n' +
            '                                            Islam, Zakir Hossain Opu, Sanam Gulrokh Sathi, Fahim Mahmud Mridul.'
    },
]

SwiperCore.use([Navigation]);

const PublicLectureDetails = () => {
    const dispatch = useDispatch()
    const getData = useSelector(store => store.posts)
    let {slug} = useParams();



    // api call
    useEffect(() => {
        let api_url = apiEndPoints.POSTS
        dispatch(fetchPostDetail([api_url + `/${slug}`]))
    }, [])

    return (

        <HelmetProvider>
            {/*dynamic title */}
            <Helmet>
                <meta charSet="utf-8"/>
                <title>{getData?.detail?.title ? getData?.detail?.title : 'Office Building for Infrastructure Development Company Limited (IDCOL), Government of Bangladesh (GOB)'}</title>
                <meta name="description" content="Description"/>
            </Helmet>

            <StyledComponent>
                <DetailList sliderImageData={sliderImage} textSlideData={textSlider} />
            </StyledComponent>
        </HelmetProvider>

    );
};

const StyledComponent = styled.section`
`;

export default PublicLectureDetails;
